import React from 'react'
import type { StepProps } from './types'

export const Step: React.FC<StepProps> = ({ 
  leftContent, 
  rightContent, 
  children, 
  className = ''
}) => {
  // If children is provided, use Apple-style fullscreen layout
  if (children) {
    return (
      <div 
        className={`sticky-step sticky-step-fullscreen ${className}`}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 0,
          background: '#000000',
          color: '#ffffff',
          padding: '0 5%'
        }}
      >
        {children}
      </div>
    )
  }

  // Split layout with responsive behavior
  return (
    <div 
      className={`sticky-step sticky-step-split ${className}`}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        opacity: 0,
        padding: '0 8%',
        background: '#000000',
        color: '#ffffff'
      }}
    >
      {/* Left Side - Always visible */}
      <div 
        className="step-left"
        style={{
          flex: 1,
          padding: '0 3rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: '60vh',
          maxWidth: '600px'
        }}
      >
        {leftContent}
      </div>

      {/* Right Side - Hidden on mobile */}
      <div 
        className="step-right"
        style={{
          flex: 1,
          padding: '0 3rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh'
        }}
      >
        {rightContent}
      </div>
    </div>
  )
}